export const CreditConfig: any = {
  id: "16073749924003706375390585",
  name: "Ai-Credits",
  price: "9.99",
  localPrice: null,
  key: "AI.CREDITS",
};
